export const TAX_TYPES = {
  SalesTax: {
    Code: '01',
    Description: 'Sales Tax',
  },
  ServiceTax: {
    Code: '02',
    Description: 'Service Tax',
  },
  TourismTax: {
    Code: '03',
    Description: 'Tourism Tax',
  },
  HighValueGoodsTax: {
    Code: '04',
    Description: 'High-Value Goods Tax',
  },
  SalesTaxOnLowValueGoods: {
    Code: '05',
    Description: 'Sales Tax on Low Value Goods',
  },
  NotApplicable: {
    Code: '06',
    Description: 'Not Applicable',
  },
  TaxExemption: {
    Code: 'E',
    Description: 'Tax exemption (where applicable)',
  },
};
